import { z } from "zod";

/**
 * Share contract stub (M0 ships the type; M6 Share & Embed implements
 * snapshot generation, OG images, and the embed snippet generator). Shape
 * mirrors M6.md's documented `ShareConfig`.
 */

export const CURRENT_SHARE_SCHEMA_VERSION = 1;
export const SUPPORTED_SHARE_SCHEMA_VERSIONS = [1];

export const ShareVisibilitySchema = z.enum(["private", "unlisted", "public"]);
export type ShareVisibility = z.infer<typeof ShareVisibilitySchema>;

/**
 * Max length for the owner-authored `/map/{slug}/` description (FAIL-453) — a
 * meta-description-shaped cap, not a full article field. Client-safe (no DB
 * import) so both the SharePanel textarea and the server-side zod validation
 * (src/app/api/account/maps/[id]/share/route.ts) read the same number.
 */
export const SHARE_DESCRIPTION_MAX = 500;

export const ShareEmbedConfigSchema = z.object({
  mode: z.enum(["standard", "store_locator"]).default("standard"),
  width: z.union([z.number(), z.literal("100%")]),
  height: z.number(),
  interactive: z.boolean(),
  show_branding: z.boolean(),
  allow_nl: z.boolean(),
});
export type ShareEmbedConfig = z.infer<typeof ShareEmbedConfigSchema>;

export const ShareLiveConfigSchema = z.object({
  is_live: z.boolean(),
  refresh_policy: z.enum(["manual", "daily"]),
  last_refreshed_at: z.string().nullable(),
});
export type ShareLiveConfig = z.infer<typeof ShareLiveConfigSchema>;

export const ShareConfigSchema = z.object({
  schema_version: z.literal(CURRENT_SHARE_SCHEMA_VERSION),
  map_id: z.string(),
  visibility: ShareVisibilitySchema,
  share_slug: z.string(),
  embed: ShareEmbedConfigSchema,
  live: ShareLiveConfigSchema,
  snapshot_etag: z.string().nullable(),
  created_at: z.string(),
});
export type ShareConfig = z.infer<typeof ShareConfigSchema>;
